import { socket } from "@randajan/simple-app/fe";
import { BifrostRouter } from "@randajan/bifrost/client";
import { createBeam } from "@randajan/bifrost/client/beam";
import { useBeam } from "@randajan/bifrost/client/react";



export const bifrost = new BifrostRouter(socket);


export const userBeam = createBeam(bifrost, "/user", {
    unfold:"profile",
});


export const shopBeam =  createBeam(bifrost, "/shop");



export const docsBeam = createBeam(bifrost, "/docs");
export const varsBeam = createBeam(bifrost, "/vars");
